// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import dummyData from '@src/views/FinanceInvoiceRequests/store'

const rootReducer = {
  auth,
  navbar,
  layout,
  dummyData
}

export default rootReducer
